module.exports = __webpack_public_path__ + "img/dr-Adam-Latosinski.e8b87846.jpg";